import React from 'react';
import { NavLink } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import { servicesData } from './servicesData'; // Importing shared data
import { FaArrowRight } from 'react-icons/fa';

const Service = () => {
    React.useEffect(() => {
        AOS.init({
            offset: 150,
            duration: 800,
        });
    }, []);

    // Select specific services to feature on Home Page
    const featuredKeys = ['website-development', 'app-development', 'data-engineering', 'ai-ml'];

    return (
        <section className="services-section-home">
            <div className="container">
                <div className="text-center mb-5" data-aos="fade-up">
                    <span className="section-badge">OUR EXPERTISE</span>
                    <h2 className="section-title">
                        Engineering <span className="highlight-text">Digital Excellence</span>
                    </h2>
                    <p className="section-subtitle text-center">
                        We build scalable, future-proof ecosystems using the world's most advanced technologies.
                    </p>
                </div>

                <div className="row g-4 justify-content-center">
                    {featuredKeys.map((key, idx) => {
                        const service = servicesData[key];
                        if (!service) return null;

                        return (
                            <div className="col-lg-6 col-md-12" key={key} data-aos="fade-up" data-aos-delay={idx * 100}>
                                <div className="home-service-card">
                                    <div className="card-bg" style={{ backgroundImage: `url(${service.introImg})` }}></div>
                                    <div className="card-gradient-overlay"></div>

                                    <div className="card-content-wrapper">
                                        <div className="service-icon-floating">
                                            {service.subServices[0].icon} {/* Representative Icon */}
                                        </div>

                                        <div className="text-content">
                                            <h3 className="service-card-title">{service.heroTitle}</h3>
                                            <p className="service-card-desc text-truncate-3">
                                                {service.introText}
                                            </p>

                                            {/* Mini Tech Stack Preview */}
                                            {service.technologies && (
                                                <div className="mini-tech-stack">
                                                    {service.technologies.slice(0, 4).map((tech, i) => (
                                                        <span key={i} className="mini-tech-icon" title={tech.name}>{tech.icon}</span>
                                                    ))}
                                                </div>
                                            )}

                                            <NavLink to={`/services/${key}`} className="explore-link" onClick={() => window.scrollTo(0, 0)}>
                                                Explore Solution <FaArrowRight className="ms-2" />
                                            </NavLink>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>

                <div className="text-center mt-5" data-aos="fade-up">
                    <NavLink to="/services" className="view-all-btn" onClick={() => window.scrollTo(0, 0)}>
                        View All Technical Capabilities
                    </NavLink>
                </div>
            </div>

            <style>{`
                /* =============================================
                   HOME PAGE SERVICES REDESIGN
                   ============================================= */
                .services-section-home {
                    padding: 80px 0 100px 0;
                    background-color: #080012;
                    position: relative;
                }

                .section-badge {
                    display: inline-block;
                    padding: 5px 15px;
                    border-radius: 50px;
                    background: rgba(160, 79, 244, 0.1);
                    border: 1px solid rgba(160, 79, 244, 0.3);
                    color: #d0a0ff;
                    font-size: 0.8rem;
                    letter-spacing: 2px;
                    font-weight: 700;
                    margin-bottom: 20px;
                }

                .section-title {
                    font-size: 3.5rem;
                    font-weight: 800;
                    color: #fff;
                    margin-bottom: 15px;
                }
                .highlight-text {
                    background: linear-gradient(90deg, #a04ff4, #ffb428);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }
                .section-subtitle {
                    font-size: 1.2rem;
                    color: #b0b0b0;
                    max-width: 600px;
                    margin: 0 auto;
                }

                /* --- Card Styles --- */
                .home-service-card {
                    position: relative;
                    border-radius: 24px;
                    overflow: hidden;
                    height: 100%; min-height: 380px;
                    border: 1px solid rgba(255, 255, 255, 0.1);
                    transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
                    background: #0f0518;
                    display: flex; /* Flex to stretch overlay */
                }

                .home-service-card:hover {
                    transform: translateY(-8px);
                    box-shadow: 0 20px 50px rgba(0,0,0,0.4);
                    border-color: rgba(160, 79, 244, 0.5);
                }

                .card-bg {
                    position: absolute; inset: 0;
                    background-size: cover; background-position: center;
                    transition: transform 0.6s ease;
                    opacity: 0.4;
                }
                .home-service-card:hover .card-bg { transform: scale(1.05); opacity: 0.2; }

                .card-gradient-overlay {
                    position: absolute; inset: 0;
                    background: linear-gradient(to bottom, rgba(15, 5, 24, 0.7), rgba(15, 5, 24, 0.95) 60%);
                    z-index: 1;
                }

                .card-content-wrapper {
                    position: relative; z-index: 2;
                    padding: 40px;
                    display: flex; flex-direction: column;
                    width: 100%;
                }

                .service-icon-floating {
                    width: 60px; height: 60px;
                    background: linear-gradient(135deg, #a04ff4, #6a1b9a);
                    border-radius: 16px;
                    display: flex; align-items: center; justify-content: center;
                    font-size: 1.8rem; color: #fff;
                    margin-bottom: 25px;
                    box-shadow: 0 8px 20px rgba(160, 79, 244, 0.3);
                }

                .service-card-title {
                    font-size: 2rem;
                    font-weight: 700;
                    color: #fff;
                    margin-bottom: 12px;
                }

                .service-card-desc {
                    font-size: 1.05rem;
                    color: #c0c0c0;
                    line-height: 1.6;
                    margin-bottom: 25px;
                }
                
                .text-truncate-3 {
                    display: -webkit-box;
                    -webkit-line-clamp: 3;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                }

                .mini-tech-stack {
                    display: flex; gap: 15px;
                    margin-bottom: 30px;
                    padding-top: 15px;
                    border-top: 1px solid rgba(255,255,255,0.1);
                }
                .mini-tech-icon {
                    font-size: 1.5rem;
                    color: #a04ff4;
                    opacity: 0.8; transition: all 0.3s;
                }
                .mini-tech-icon:hover { opacity: 1; transform: scale(1.2); color: #fff; }

                .explore-link {
                    margin-top: auto;
                    display: inline-flex; align-items: center;
                    color: #fff; font-weight: 600; text-decoration: none;
                    font-size: 1rem;
                    transition: all 0.3s;
                }
                .explore-link:hover { color: #2ebf91; transform: translateX(5px); }

                .view-all-btn {
                    display: inline-block;
                    padding: 15px 40px;
                    border: 1px solid rgba(255, 255, 255, 0.2);
                    border-radius: 50px;
                    color: #fff; text-decoration: none;
                    font-weight: 600;
                    transition: all 0.3s;
                }
                .view-all-btn:hover {
                    background: #fff; color: #000;
                    box-shadow: 0 0 20px rgba(255,255,255,0.3);
                }

                @media (max-width: 768px) {
                    .section-title { font-size: 2.5rem; }
                    .card-content-wrapper { padding: 30px; }
                }
            `}</style>
        </section>
    );
};

export default Service;